module.exports = __webpack_public_path__ + "static/img/vivoNex13S_5G.7012578b.png";